import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import {Button, Container} from 'reactstrap';
import ContentLoader from "../../components/ContentLoader";
import { Request, handlePublicRequestError } from '../../helpers/request'
import { injectIntl } from 'react-intl'
import { addLocalePrefix } from '../../components/Routes/LocaleLink'
import {getCandidateJobOrderAlertsListRoute} from "../../helpers/route";
import { toast } from 'react-toastify';

class CandidateAlertsPage extends Component
{
    state = {
        data: null
    };

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        const email = this.props.match.params.email;
        const params = new URLSearchParams(this.props.location.search);

        Request.get(getCandidateJobOrderAlertsListRoute(email, params.get('h')))
            .then((response) => {
                const data = response.data;
                this.setState({ data })
            })
            .catch(() => {
                this.props.history.push(addLocalePrefix('/404'));
            });
    }

    onAlertIsActiveCheckboxClick(event) {
        const checkbox = event.target
        const id = checkbox.value
        const isActive = checkbox.checked

        const data = this.state.data
        if(data.length) {
            data.map((alert) => {
                if(alert.id.toString() === id) {
                    alert.is_active = isActive
                }
                return alert
            })
        }
        this.setState({data: data})
    }

    delete(alertId) {
        const { success } = toast
        console.log(alertId, `candidate_job_order_alert/${alertId}`)
        Request.delete(`candidate_job_order_alert/${alertId}`)
            .then(() => {
                success(`alerte supprimée`)
                this.fetch()
        }).catch(handlePublicRequestError)
    }

    submit() {
        const { success } = toast
        const {data : stateData} = this.state
        const data = stateData.map((alert) => {
            return {id: alert.id, is_active: alert.is_active ? 1 : 0}
        })

        Request.put('candidate_job_order_alert/update_candidate_alerts_active', {alerts: data})
            .then(() => {
                success('Modifications sur les alertes enregistrées')
        }).catch(handlePublicRequestError)
    }

    renderAlerts() {
        const {data} = this.state;
        if(!data.length) {
            return null
        }
        return (<>
            {data.map((alert) => {
                return (this.renderAlert(alert))
            })}
        </>)
    }

    renderAlert(alert) {
        const {intl} = this.props

        const {
            id,
            business_unit,
            business_unit_category,
            location,
            search_string,
            salary_min,
            salary_max,
            remote,
            title,
            is_active,
        } = alert

        const remoteTranslation = (remote) ? intl.formatMessage({
            id: `open_to_remote_type.${remote}`,
            defaultMessage: ""
        }) : ""

        return (
            <div className={"alert-wrap"} key={id}>
                <p className={"alert-header"}>
                    <span className={"alert-header-title"}>
                        {title}
                    </span>
                    <span onClick={() => {this.delete(id)}}>
                        <FontAwesomeIcon icon={faTrashAlt} className='icon' />
                    </span>
                </p>

                <p className={"alert-content"}>
                    {business_unit ? <span>{business_unit}</span> : ""}
                    {business_unit_category?.label ? <span>{business_unit_category.label}</span> : ""}
                    {search_string ? <span>{search_string}</span> : ""}
                    {salary_min ? <span>{salary_min} k€ </span> : ""}
                    {salary_max ? <span>{salary_max} k€ </span> : ""}
                    {location ? <span>{location}</span> : ""}
                    <span>{remoteTranslation}</span>
                </p>

                <p className="alert-switch">
                    <label className="switch" >
                        <input
                            type="checkbox"
                            value={id}
                            onChange={(e) => this.onAlertIsActiveCheckboxClick(e)}
                            checked={is_active}
                        />
                        <span className="slider round"></span>
                    </label>
                    Être notifié par email
                </p>
            </div>
        )
    }

    render() {
        const {data} = this.state;

        if (!data)
            return <ContentLoader/>;

        return (
            <div className="candidates-alerts-page">
                <section className="candidate-alerts">
                    <Container>
                        <div className="alerts-head">
                            <h1 className="line-heading">
                                Gérer mes recherches
                            </h1>
                        </div>
                        <div className="alerts-wrap">
                            {this.renderAlerts()}
                        </div>
                        <div className={"btn-wrap"}>
                            <Button className="btn btn-danger btn-secondary" color=''
                                    onClick={() => this.submit()}>
                                Confirmer
                            </Button>
                        </div>
                    </Container>
                </section>
            </div>
        )
    }

}

export default injectIntl(CandidateAlertsPage);
